import { sendTrackingEvent } from '../services/service.tracking';
import { getVehicleQuestionData } from '../utils/utils.tracking';

const tabToEventElement = {
  questionsExhaust: 'ico_mods_exhaust',
  questionsPerformance: 'ico_mods_performance',
  questionsStereo: 'ico_mods_stereo',
  questionsSuspension: 'ico_mods_suspension',
  questionsWheelsTires: 'ico_mods_wheels-tires',
};

export const trackKeysModificationsLoad = () => {
  sendTrackingEvent({
    event: 'analytics_event',
    eventAction: 'impression',
    eventResult: 'ico_mods',
    eventNonInteractive: false,
    eventData: getVehicleQuestionData(),
  });
};

export const trackModificationsSelection = (button: string) => {
  const selection = tabToEventElement[button];

  sendTrackingEvent({
    event: 'analytics_event',
    eventAction: 'click',
    eventResult: selection,
    eventNonInteractive: false,
    eventData: getVehicleQuestionData(),
  });
};
